// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1P6rB","question":"styles_question__2GrgV","description":"styles_description__2twwW"};